import {
  NumberedHeader,
  NumberedHTMLWrapper,
  NumberedSectionContainer,
  SectionHeader,
} from './SectionStyledComponents';

const NumberedSection = props => {
  return (
    <NumberedSectionContainer>
      {!props.isStep && <SectionHeader>{props.section.title}</SectionHeader>}
      <ol
        style={{
          padding: 0,
          margin: '0 18px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        {props.section.content.map((content, index) => {
          if (!content.header || !content.body) return <></>;

          return (
            <li
              key={`${props.section.title}-${content.header}-
          ${index}`}
            >
              <NumberedHeader>{content.header}</NumberedHeader>
              <NumberedHTMLWrapper innerHtml={content.body} />
            </li>
          );
        })}
      </ol>
    </NumberedSectionContainer>
  );
};

export default NumberedSection;
